// extracted by mini-css-extract-plugin
export default {"loadingEllipsis":"LoadingEllipsis_loadingEllipsis__06pQF","float":"LoadingEllipsis_float__+-uCx"};